import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { apiPost } from "../api/http";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../context/ToastContext";
import { parseApiError } from "../utils/apiErrors";

export default function SetupAccount() {
  const { login } = useAuth();
  const { showError, showSuccess } = useToast();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [token, setToken] = useState("");
  const [name, setName] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const t = searchParams.get("token");
    if (t) {
      setToken(t);
    } else {
      setError("Setup token is missing or invalid. Please check your invitation email.");
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!token) return;

    if (password.length < 6) {
      showError("Password must be at least 6 characters long.");
      return;
    }

    if (password !== confirmPassword) {
      showError("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      const { data } = await apiPost("/api/auth/setup-account", {
        token,
        name: name.trim(),
        password,
      });

      showSuccess("Account set up successfully!");
      login(data.token, data.expiresAt, data.refreshToken, true);
      navigate("/dashboard", { replace: true });
    } catch (err) {
      showError(parseApiError(err, "Failed to complete account setup"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page auth-container" style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "75vh" }}>
      <div className="card auth-card" style={{ maxWidth: "440px", width: "100%", padding: "32px", position: "relative" }}>
        <h1 className="page-title" style={{ fontSize: "1.75rem", textAlign: "center", marginBottom: "8px" }}>
          Welcome to Nova SEO
        </h1>
        <p style={{ color: "var(--text-muted)", fontSize: "0.9rem", textAlign: "center", marginBottom: "24px" }}>
          Complete your profile and set up your account password to join your workspace.
        </p>

        {error ? (
          <div style={{
            background: "rgba(239, 68, 68, 0.1)",
            border: "1px solid rgba(239, 68, 68, 0.2)",
            color: "var(--danger)",
            padding: "12px",
            borderRadius: "8px",
            fontSize: "0.88rem",
            marginBottom: "20px",
            textAlign: "center"
          }}>
            {error}
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "grid", gap: "16px" }}>
            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontSize: "0.85rem", fontWeight: 600 }}>Your Name</label>
              <input
                className="input"
                type="text"
                placeholder="John Doe"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontSize: "0.85rem", fontWeight: 600 }}>Password</label>
              <input
                className="input"
                type="password"
                placeholder="At least 6 characters"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
              <label style={{ fontSize: "0.85rem", fontWeight: 600 }}>Confirm Password</label>
              <input
                className="input"
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              style={{ width: "100%", padding: "12px", fontSize: "1rem", fontWeight: "600", marginTop: "8px" }}
              disabled={loading}
            >
              {loading ? "Setting up account..." : "Set Password & Enter"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
